import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { TrackedLinkDirective } from 'src/app/core/analytics/directives/tracked-link.directive';

@Component({
  selector: 'app-footer',
  imports: [CommonModule, TranslatePipe, TrackedLinkDirective],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  currentYear = new Date().getFullYear();

  rocketProducts = [
    {
      trackId: 'redfin',
      titleKey: 'footer.products.redfin.title',
      descriptionKey: 'footer.products.redfin.description',
      url: 'https://www.redfin.com/',
    },
    {
      trackId: 'rocket-mortgage',
      titleKey: 'footer.products.rocketMortgage.title',
      descriptionKey: 'footer.products.rocketMortgage.description',
      url: 'https://rocket.com/mortgage/',
    },
    {
      trackId: 'rocket-money',
      titleKey: 'footer.products.rocketMoney.title',
      descriptionKey: 'footer.products.rocketMoney.description',
      url: 'https://www.rocketmoney.com/',
    },
    {
      trackId: 'rocket-card',
      titleKey: 'footer.products.rocketCard.title',
      descriptionKey: 'footer.products.rocketCard.description',
      url: 'https://www.rocketcard.com/',
    },
    {
      trackId: 'rocket-loans',
      titleKey: 'footer.products.rocketLoans.title',
      descriptionKey: 'footer.products.rocketLoans.description',
      url: 'https://www.rocketloans.com/',
    },
    {
      trackId: 'rocket-pro',
      titleKey: 'footer.products.rocketPro.title',
      descriptionKey: 'footer.products.rocketPro.description',
      url: 'https://www.rocketpro.com/',
    },
    {
      trackId: 'rocket-close',
      titleKey: 'footer.products.rocketClose.title',
      descriptionKey: 'footer.products.rocketClose.description',
      url: 'https://www.rocketclose.com/',
    },
  ];

  rocketCloseLinks = [
    {
      trackId: 'buy-or-sell',
      textKey: 'footer.rocketClose.buyOrSell',
      url: 'https://www.rocketclose.com/home-buyers-sellers/about-title-insurance',
    },
    {
      trackId: 'brokers',
      textKey: 'footer.rocketClose.brokers',
      url: 'https://www.rocketclose.com/broker-title-escrow',
    },
    {
      trackId: 'partners',
      textKey: 'footer.rocketClose.partners',
      url: 'https://www.rocketclose.com/partners',
    },
    {
      trackId: 'funding',
      textKey: 'footer.rocketClose.funding',
      url: 'https://www.rocketclose.com/funding',
    },
    {
      trackId: 'clear-sign',
      textKey: 'footer.rocketClose.clearSign',
      url: 'https://www.rocketclose.com/applications-and-services/clear-sign',
    },
    {
      trackId: 'careers',
      textKey: 'footer.rocketClose.careers',
      url: 'https://www.myrocketcareer.com/',
    },
  ];

  legalLinks = [
    {
      trackId: 'privacy-policy',
      textKey: 'footer.legal.privacyPolicy',
      url: 'https://www.rocketclose.com/privacy-policy',
    },
    {
      trackId: 'terms-of-use',
      textKey: 'footer.legal.termsOfUse',
      url: 'https://www.rocketclose.com/terms-of-use',
    },
    {
      trackId: 'disclosures',
      textKey: 'footer.legal.disclosures',
      url: 'https://www.rocketclose.com/disclosures-licenses',
    },
    {
      trackId: 'do-not-sell',
      textKey: 'footer.legal.doNotSell',
      url: 'https://info.rocketclose.com/state-privacy/',
    },
  ];

  supportLinks = [
    {
      trackId: 'contact-us',
      textKey: 'footer.support.contactUs',
      url: 'https://www.rocketclose.com/contact',
    },
    {
      trackId: 'login',
      textKey: 'footer.support.login',
      url: 'https://www.rocketclose.com/login',
    },
    {
      trackId: 'partner-registration',
      textKey: 'footer.support.partnerRegistration',
      url: 'https://portal.rocketclose.com/Register',
    },
  ];

  socialLinks = [
    {
      trackId: 'facebook',
      name: 'Facebook',
      icon: 'assets/icons/facebook-default.svg',
      url: 'https://www.facebook.com/RocketClose',
    },
    {
      trackId: 'instagram',
      name: 'Instagram',
      icon: 'assets/icons/instagram-default.svg',
      url: 'https://www.instagram.com/rocketclose/',
    },
    {
      trackId: 'linkedin',
      name: 'LinkedIn',
      icon: 'assets/icons/linkedin-default.svg',
      url: 'https://www.linkedin.com/company/rocketclose',
    },
  ];
}
